import Head from 'expo-router/head';

import { OfferDetailScreen } from '@fhs/loyalty';
import { withStoreSelected } from '@fhs-legacy/frontend/src/components/store-selected';

export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

function OfferDetails() {
  return (
    <>
      <Head>
        <title>Offer Details - Firehouse Subs</title>
      </Head>
      <OfferDetailScreen />
    </>
  );
}

export default withStoreSelected(OfferDetails);
